/**
 * Labstep
 *
 * @module components/Metadata/Card/Preview
 * @desc Metadata card preview
 */

import { MetadataValue } from 'labstep-web/components/Metadata/Value';
import { ICONS } from 'labstep-web/constants/icons';
import { GenericCard as CardGeneric } from 'labstep-web/core/Card/Generic';
import { Icon } from 'labstep-web/core/Icon';
import type React from 'react';
import type { MetadataCardPreviewProps } from './types';

export const MetadataCardPreview: React.FC<
  MetadataCardPreviewProps
> = ({ metadata }) => (
  <CardGeneric
    headerImage={<Icon name={ICONS.metadata.default} />}
    headerHeader={
      <div>
        <span>{metadata.label}</span>
        <MetadataValue metadata={metadata} canEdit={false} />
      </div>
    }
  />
);
